module.exports = __webpack_public_path__ + "img/yunming-wang-1408276-unsplash.bcfc9fa0.jpg";